import { createSlice, PayloadAction } from '@reduxjs/toolkit'

const initialState = {
  opened: false
}

const virtualKeyboard = createSlice({
  name: 'virtualKeyboard',
  initialState,
  reducers: {
    changeState: (state, { payload }: PayloadAction<boolean>) => {
      state.opened = payload
    }
  }
})

export const {
  changeState: _changeState
} = virtualKeyboard.actions

export default virtualKeyboard.reducer
